import React from 'react';
import { simTokens } from './tokens';

type SimBadgeVariant =
  | 'neutral'
  | 'flag'
  | 'integrity-high'
  | 'integrity-medium'
  | 'integrity-low'
  | 'evidence-correct'
  | 'evidence-incorrect';

type SimBadgeProps = {
  children: React.ReactNode;
  variant?: SimBadgeVariant;
  className?: string;
};

const variantClassMap: Record<SimBadgeVariant, string> = {
  neutral: simTokens.badgeNeutral,
  flag: simTokens.badgeFlag,
  'integrity-high': simTokens.badgeIntegrityHigh,
  'integrity-medium': simTokens.badgeIntegrityMedium,
  'integrity-low': simTokens.badgeIntegrityLow,
  'evidence-correct': simTokens.badgeEvidenceCorrect,
  'evidence-incorrect': simTokens.badgeEvidenceIncorrect,
};

const SimBadge: React.FC<SimBadgeProps> = ({ children, variant = 'neutral', className = '' }) => {
  return <span className={`${simTokens.badgeBase} ${variantClassMap[variant]} ${className}`}>{children}</span>;
};

export default SimBadge;
